import { FC } from 'react';
import { Box, Flex, Heading, List, ListItem } from '@chakra-ui/react';

import Text from 'components/_core/Text';
import OfferListIcon from 'features/Insurance/components/OfferListIcon';

export interface IGuarantees {
  title: string;
  items: readonly string[];
}

interface GuaranteesListProps {
  guarantees: IGuarantees;
  isInclude: boolean;
}

const GuaranteesList: FC<GuaranteesListProps> = ({ guarantees, isInclude }) => {
  const { items, title } = guarantees;

  return (
    <Box>
      <Heading paddingBottom="space-16">{title}</Heading>

      <List spacing="space-16">
        {items.map((text) => (
          <ListItem alignItems="baseline" as={Flex} key={text}>
            <OfferListIcon
              color="lightBlue.0"
              name={isInclude ? 'tick' : 'cross'}
            />
            <Text>{text}</Text>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default GuaranteesList;
